module.exports = __webpack_public_path__ + "static/aop (2)-e418023d45fe646856dfa8fc327dfd1a.jpg";